module.exports = __webpack_public_path__ + "nunito-sans-latin-300.f16977f35222a4cce7d6f4336732a67a.woff2";